import { hasDayGuests } from '../guests'
import type { InvitedPerson } from '../types'
import { weddingInfo } from '../weddingInfo'
import { SectionHeading } from './SectionHeading'
import { Timeline } from './Timeline'

/**
 * The running order, tailored to what the invite actually covers.
 *
 * An evening-only invite gets the part that applies to them up front, with the
 * earlier half kept below and clearly marked. Hiding the day entirely would just
 * make the timeline look like it starts oddly late; leading with it would bury
 * the bit they need.
 */
export function RunningOrder({ people }: { people: readonly InvitedPerson[] }) {
  const dayPart = weddingInfo.timeline.filter((slot) => slot.audience === 'day')
  const everyonePart = weddingInfo.timeline.filter((slot) => slot.audience === 'all')

  if (hasDayGuests(people)) {
    return (
      <section aria-labelledby="the-day">
        <SectionHeading id="the-day">The day</SectionHeading>
        <Timeline slots={weddingInfo.timeline} />
      </section>
    )
  }

  return (
    <section aria-labelledby="the-evening">
      <SectionHeading id="the-evening">Your evening</SectionHeading>
      <Timeline slots={everyonePart} />

      <h3 className="text-ink-soft mt-8 text-xs tracking-[0.25em] uppercase">
        Earlier, for the day guests
      </h3>
      <div className="opacity-55">
        <Timeline slots={dayPart} />
      </div>
    </section>
  )
}
